export default {
  abandonProduct: 'Porzuć produkt',
  abandonProductTips:
    'Przyjazne przypomnienie: Po potwierdzeniu [Porzuć produkt], zniszczymy Twój produkt i nie będzie można go odzyskać. Produkt nie zostanie zwrócony sprzedawcy w celu zwrotu pieniędzy. Prosimy o ostrożność.',
  finePhotos: 'Szczegółowe zdjęcia',
  ordinaryPhotos: 'Zwykłe zdjęcie',
  expireText: 'Paczka wkrótce wygaśnie',
  more: 'Więcej',
  timeExpand: 'Wydłużony czas',
  guaranteeService: 'Usługa gwarancyjna',
  noNeed: 'Nie potrzebuję',
  'i18n-0000002':
    'Okres przechowywania przedmiotu minął. Przechowamy go przez dodatkowe 28 dni. Po upływie tego okresu przedmiot zostanie uznany za porzucony i odpowiednio zutylizowany.',
  'i18n-0000003':
    'Jeśli chcesz przedłużyć okres przechowywania, kup usługę o wartości dodanej na przedłużone przechowywanie w ciągu 28 dni.',
  'i18n-0000004': 'Czas wygaśnięcia pamięci masowej',
  'i18n-0000016': 'Okres przechowywania produktu wygasł',
  'i18n-0000019':
    'Jeżeli użytkownik nie odnowi usługi przechowywania, produkt zostanie domyślnie porzucony',
  'i18n-0000023': 'Zakończony',
  refundTip: 'Po potwierdzeniu opłata za przechowywanie zostanie zwrócona na Twoje konto.',
  storageEnum: {
    1: 'Magazyn 1, Chiny',
    2: 'Magazyn 2, Chiny',
  },
  'i18n-00001':
    'Zgadzam się na zmiany w informacjach zawartych w mojej deklaracji, dostarczonych przez acbuy, w celu dostosowania ich do lokalnych wymogów celnych i poprawy stawek celnych. W przypadku niewykupienia ubezpieczenia ponoszę wyłączną odpowiedzialność za wszelkie wynikające z tego obowiązki i konsekwencje związane z odprawą celną.',
  'i18n-00002':
    'Nie zgadzam się na zmiany. Proszę o złożenie deklaracji w obecnej formie. Ponoszę wyłączną odpowiedzialność za wszelkie wynikające z tego obowiązki i konsekwencje związane z odprawą celną.',
  'i18n-00003': 'Zgadzam się na zmianę',
  'i18n-00004': 'Nie zgadzam się na zmianę',
  'i18n-00005': 'Zmiana informacji zawartych w deklaracji',
  'i18n-00006':
    'Każda treść deklaracji musi zawierać więcej niż 25 znaków. Prosimy o dostosowanie i ponowne przesłanie.',
  'i18n-00007':
    'Na podstawie większej z wartości: wagi rzeczywistej lub wolumetrycznej. Wszelkie różnice zostaną zwrócone lub naliczone w ciągu 72 godzin od zapakowania.',
  'i18n-00008':
    'Każda deklaracja musi mieć mniej niż {length} znaków, dostosuj i prześlij ponownie',
  'i18n-00009':
    '{AI} ma jeszcze nieopłacone usługi o wartości dodanej. Aby je zachować, proszę dokończyć płatność i poczekać na zakończenie usługi przed zgłoszeniem paczki. Jeśli zdecydujesz się zgłosić paczkę teraz, system automatycznie anuluje odpowiednie usługi o wartości dodanej, które pozostają nieopłacone.',
}
